/*eslint-disable*/ export const messages = {
    "Go to the first page": "Ir a la primera página",
    "Go to the last page": "Ir a la última página",
    "Pagination, showing {from} through {to} of {total} entities": [
        "Paginación, mostrando de la ",
        ["from"],
        " a la ",
        ["to"],
        " de ",
        ["total"],
        " entidades",
    ],
    "Show next {entitiesPerPage} entities": ["Mostrar las siguientes ", ["entitiesPerPage"], " entidades"],
    "Show previous {entitiesPerPage} entities": ["Mostrar las anteriores ", ["entitiesPerPage"], " entidades"],
    "{from} through {to} of {total}": ["De la ", ["from"], " a la ", ["to"], " de ", ["total"]],
    "{from}-{to} of {total}": [["from"], "-", ["to"], " de ", ["total"]],
};
